import { FilterKey } from './filters';

export const searchFilters = [
  'searchQuery',
  'inAssortment',
  'purchasePrice',
  'discontinuedItem',
  'fromMainSupplier',
  'supplierNumbers',
  'productGroupNumbers',
  'discountGroupCodes',
] as const satisfies FilterKey[];
export type SearchFilters = (typeof searchFilters)[number];

export const itemBulkActions = [
  'supplierModal',
  'discountGroupModal',
  'productGroupModal',
  'searchQueryModal',
] as const satisfies FilterKey[];
export type BulkActionsFilters = (typeof itemBulkActions)[number];

export const insightFilters = [
  'subAssortmentIds',
  'supplierNumber',
  'productGroupNumber',
  'searchQuery',
  'inAssortment',
] as const satisfies FilterKey[];
export type InsightFilters = (typeof insightFilters)[number];

export const calculusFilters = [
  'productGroupNumber',
  'discountGroupCode',
  'itemSearchQuery',
  'hierarchyLevel',
  'conditionState',
  'assortmentType',
] as const satisfies FilterKey[];
export type CalculusFilters = (typeof calculusFilters)[number];

export const levelFilters = [
  'supplierNumber',
  'discountGroupCodes',
  'productGroupNumbers',
  'searchQuery',
] as const satisfies FilterKey[];
export type LevelFilters = (typeof levelFilters)[number];
